import ChartFactory from "blocks/reports/custom-report/chart-factory";
import Report from "blocks/reports/base/report";
import { memo } from "react";

export const Preview = memo(function ({
  filters = [],
  measures = [],
  timeDimensions = [],
  dimensions = [],
  order = undefined,
  limit = 12,
  compare = false,
  compareDateRange = "",
  dataType = "single",
  chartType = "LINE",
}) {
  return (
    <Report
      renderHeader={() => null}
      measures={measures}
      timeDimensions={timeDimensions}
      dimensions={dimensions}
      filters={filters}
      order={order}
      limit={limit}
      draggable={false}
      applyGlobalFilters={false}
      applyDateRangeFilter={false}
      smartFilterSelection={false}
      dataType={
        dataType ??
        (timeDimensions?.length && timeDimensions[0]?.granularity
          ? "time_series"
          : "single")
      }
    >
      {(response) => {
        return (
          <ChartFactory
            chartType={chartType}
            {...response}
            hideLegend={true}
            compare={false}
            dataType={dataType}
          />
        );
      }}
    </Report>
  );
});
